import { render, staticRenderFns } from "./ManagUsers.vue?vue&type=template&id=5964cb9f&scoped=true&"
import script from "./ManagUsers.vue?vue&type=script&lang=js&"
export * from "./ManagUsers.vue?vue&type=script&lang=js&"
import style0 from "./ManagUsers.vue?vue&type=style&index=0&id=5964cb9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5964cb9f",
  null
  
)

export default component.exports